import { BaseServiceDefinition } from './BaseService';

class ConfigsServiceDefinition extends BaseServiceDefinition {

    getPointStyleRules(): Promise<any> {
        return this.get('/api/v1/configs/pointStyleRules');
    }
}

export const ConfigsService: ConfigsServiceDefinition
    = new ConfigsServiceDefinition();